export default function CtaBand() {
  return (
    <section className="bg-background-50 py-12 md:py-16" aria-label="加入讨论引导">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-primary-500 px-6 py-12 text-center md:px-12 md:py-16">
          <i
            className="ri-chat-quote-line absolute -right-6 -top-6 text-[7rem] text-background-50/15"
            aria-hidden="true"
          ></i>
          <i
            className="ri-chat-3-line absolute -bottom-8 -left-6 text-[7rem] text-background-50/10"
            aria-hidden="true"
          ></i>
          <div className="relative mx-auto max-w-2xl">
            <h2 className="text-2xl font-bold leading-snug text-background-50 md:text-3xl">
              吃到的瓜，说出来才过瘾
            </h2>
            <p className="mx-auto mt-3 text-sm leading-relaxed text-background-100 md:text-base">
              带上你的观点加入讨论，让这场群聊里有你的一票。不同的声音，正在这里等你。
            </p>
            <div className="mt-7 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href="#hot"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-200"
              >
                先去热榜围观
                <i className="ri-eye-line ml-1.5" aria-hidden="true"></i>
              </a>
              <a
                href="#about"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/15"
              >
                <i className="ri-edit-2-line mr-1.5" aria-hidden="true"></i>
                现在就参与讨论
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}